module.exports = __webpack_public_path__ + "img/princial-about-us.eaf25553.jpg";